import { QualtricsApiService } from './qualtrics-api.service';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from "@angular/core";
import { NgxSpinnerService } from 'ngx-spinner';
import { DashboardInfo } from '../models/dashboard-info';

@Injectable()
export class DashboardResolver {
    constructor(private readonly qualtricsApiService: QualtricsApiService, private readonly spinner: NgxSpinnerService) {}

    resolve(route: ActivatedRouteSnapshot) {
      const dashboardInfo =  this.qualtricsApiService.getDashboardInfo(route.paramMap.get('orgid'), route.paramMap.get('surveyids'));
      return dashboardInfo;
    } 

}
